/* 🤖 this file was generated by svg-to-ts */
export const prizmIconsPower: {
  name: 'power';
  data: string;
} = {
  name: 'power',
  data: `<svg fill="none" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24"><path fill-rule="evenodd" clip-rule="evenodd" d="M13 2a1 1 0 1 0-2 0v10a1 1 0 1 0 2 0V2ZM8.445 4.831a1 1 0 1 0-.89-1.791A10 10 0 0 0 2 12c0 5.523 4.477 10 10 10s10-4.477 10-10a10 10 0 0 0-5.555-8.96 1 1 0 1 0-.89 1.791 8 8 0 1 1-7.11 0Z" fill="currentColor"/></svg>`,
};
